export const EQUIPMENT_CREATE_REQUESTED = 'EQUIPMENT_CREATE_REQUESTED';
export const EQUIPMENT_CREATE_SUCCEEDED = 'EQUIPMENT_CREATE_SUCCEEDED';
export const EQUIPMENT_CREATE_FAILED = 'EQUIPMENT_CREATE_FAILED';

export const EQUIPMENT_UPDATE_REQUESTED = 'EQUIPMENT_UPDATE_REQUESTED';
export const EQUIPMENT_UPDATE_SUCCEEDED = 'EQUIPMENT_UPDATE_SUCCEEDED';
export const EQUIPMENT_UPDATE_FAILED = 'EQUIPMENT_UPDATE_FAILED';

export const EQUIPMENT_DELETE_REQUESTED = 'EQUIPMENT_DELETE_REQUESTED';
export const EQUIPMENT_DELETE_SUCCEEDED = 'EQUIPMENT_DELETE_SUCCEEDED';
export const EQUIPMENT_DELETE_FAILED = 'EQUIPMENT_DELETE_FAILED';

export const EQUIPMENT_SET = 'EQUIPMENT_SET';
export const EQUIPMENT_SINGLE_SET = 'EQUIPMENT_SINGLE_SET';
